const defaultUserInfo = {
    username: "",
    jwt_token: ""
};

export default {
    namespaced: true,
    actions: {
        set(context, data) {
            context.commit("set", data);
        },
        logout(context) {
            context.commit("logout");
        }
    },
    mutations: {
        set(state, data) {
            // 确保 state.info 存在
            if (!state.info) {
                state.info = { ...defaultUserInfo };
            }
            state.info.username = data.username;
            state.info.jwt_token = data.jwt_token;

            localStorage.setItem("token", data.jwt_token);
            localStorage.setItem("user", JSON.stringify(state.info));
        },
        logout(state) {
            if (state.info) {
                state.info = { ...defaultUserInfo };
                localStorage.removeItem("token");
                localStorage.removeItem("user");
            }
        }
    },
    state: () => ({
        info: JSON.parse(localStorage.getItem("user")) || { ...defaultUserInfo }
    }),
    getters: {
        userData(state) {
            return state.info;
        }
    }
};